// @import dependencies
import React, { CSSProperties } from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { Modal } from 'react-bootstrap';
// @end dependencies

// @import components
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import CourseSchedulingAssociate from '../CourseSchedulingAssociate/CourseSchedulingAssociate';
// @end components

// @import types
// @end types

// @import services
import UserService from 'app_services/user/userService'
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ModalCourseSchedulingAssociate.scss'
// @end styles

interface IModalCourseSchedulingAssociateProps {
  open: boolean
  title?: string
  className?: string
  classNameModal?: string
  style?: CSSProperties
  id?: string
  onClose?: (data: any)=>any
  courseSchedulingId: string
}

const ModalCourseSchedulingAssociate: React.FC<IModalCourseSchedulingAssociateProps> = (props) => {

  const userService: UserService = new UserService()

  /**
   * @INFO Click en cerrar
   */
   const handleClickClose = () => {
    if(props.onClose){
      props.onClose({status: 'closed'})
    }
  }

  const handleFormSaved = (data: any) => {
    if (props.onClose) {
      props.onClose({
        status: 'saved',
        data,
      })
    }
  }

  return(
    <Modal
      className={`modal-course-scheduling-associate-container ${props.classNameModal ? props.classNameModal : ''}`}
      show={props.open}
      onHide={handleClickClose}
      centered
      size='lg'
    >
      <Modal.Body
        style={{
          padding: '0px'
        }}
      >
        <div
          className={`modal_course_scheduling_associate-layout ${props.className ? props.className : ''}`}
          style={props.style}
          id={props.id}
        >
          <AiOutlineCloseCircle
            className='close-icon'
            onClick={handleClickClose}
          />
          {props.title ?
            <TextComponent
              type='subtitle'
            >
              {props.title}
            </TextComponent>
          :null}
          {userService.can('permission:course_scheduling_associations_view', 'module:course_scheduling') ? (
            <CourseSchedulingAssociate
              courseSchedulingId={props.courseSchedulingId}
              onHandleSubmit={handleFormSaved}
              enabledAddAssociation={userService.can('permission:course_scheduling_associations_add', 'module:course_scheduling')}
              enabledAddAssociationForm={userService.can('permission:course_scheduling_associations_add', 'module:course_scheduling')}
            />
          ) : (
            <div className="alert alert-info">
              No tiene acceso al modulo, por favor contacte al administrador
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalCourseSchedulingAssociate;
